export enum MessageSeverity {
    Error = "danger",
    Success = "success",
    Warning = "warning",
    Info = "info"
}